import { useMemo } from 'react';

import { useGetProductCategoriesQuery } from '@/api/hooks/queries/use-get-product-categories-query';
import { categoryIdsToLabels } from '@/lib/products';

import { useActiveProductSteps } from './use-product-selection-step';
import { useSessionStore } from './use-session-store/use-session-store';

/**
 * Labels the benefits preview scopes to: the categories the patient picked, plus any category
 * they will still be asked about because it has a step without a card on `/0`.
 */
export function useEffectiveCategoryLabels(): string[] {
  const selectedCategoryIds = useSessionStore((s) => s.selectedCategoryIds);
  const { data: productCategories } = useGetProductCategoriesQuery();
  const activeSteps = useActiveProductSteps();

  return useMemo(
    () =>
      Array.from(
        new Set([
          ...categoryIdsToLabels(selectedCategoryIds, productCategories),
          ...activeSteps.map((step) => step.id),
        ])
      ),
    [selectedCategoryIds, productCategories, activeSteps]
  );
}
